export interface LumaOptions {
  loop: boolean;
  aspectRatio: string;
}

export const defaultLumaOptions: LumaOptions = {
  loop: false,
  aspectRatio: '9:16',
};
